const CHANNEL_CLEAR_ERROR = 'bfb/stakeholderMap/channels/CHANNEL_CLEAR_ERROR';
const CHANNELS_LIST = 'bfb/stakeholderMap/channels/CHANNELS_LIST';
const CHANNELS_LIST_SUCCEEDED = 'bfb/stakeholderMap/channels/CHANNELS_LIST_SUCCEEDED';
const CHANNELS_LIST_FAILED = 'bfb/stakeholderMap/channels/CHANNELS_LIST_FAILED';
const CHANNEL_CREATE = 'bfb/stakeholderMap/channels/CHANNEL_CREATE';
const CHANNEL_CREATE_SUCCEEDED = 'bfb/stakeholderMap/channels/CHANNEL_CREATE_SUCCEEDED';
const CHANNEL_CREATE_FAILED = 'bfb/stakeholderMap/channels/CHANNEL_CREATE_FAILED';
const CHANNEL_DELETE = 'bfb/stakeholderMap/channels/CHANNEL_DELETE';
const CHANNEL_DELETE_SUCCEEDED = 'bfb/stakeholderMap/channels/CHANNEL_DELETE_SUCCEEDED';
const CHANNEL_DELETE_FAILED = 'bfb/stakeholderMap/channels/CHANNEL_DELETE_FAILED';
const CHANNEL_FETCH = 'bfb/stakeholderMap/channels/CHANNEL_FETCH';
const CHANNEL_FETCH_SUCCEEDED = 'bfb/stakeholderMap/channels/CHANNEL_FETCH_SUCCEEDED';
const CHANNEL_FETCH_FAILED = 'bfb/stakeholderMap/channels/CHANNEL_FETCH_FAILED';
const CHANNEL_UPDATE = 'bfb/stakeholderMap/channels/CHANNEL_UPDATE';
const CHANNEL_UPDATE_SUCCEEDED = 'bfb/stakeholderMap/channels/CHANNEL_UPDATE_SUCCEEDED';
const CHANNEL_UPDATE_FAILED = 'bfb/stakeholderMap/channels/CHANNEL_UPDATE_FAILED';

export default {
  CHANNELS_LIST,
  CHANNELS_LIST_SUCCEEDED,
  CHANNELS_LIST_FAILED,
  CHANNEL_CLEAR_ERROR,
  CHANNEL_CREATE,
  CHANNEL_CREATE_SUCCEEDED,
  CHANNEL_CREATE_FAILED,
  CHANNEL_DELETE,
  CHANNEL_DELETE_SUCCEEDED,
  CHANNEL_DELETE_FAILED,
  CHANNEL_FETCH,
  CHANNEL_FETCH_SUCCEEDED,
  CHANNEL_FETCH_FAILED,
  CHANNEL_UPDATE,
  CHANNEL_UPDATE_SUCCEEDED,
  CHANNEL_UPDATE_FAILED,
};
